    import { Component, OnInit } from '@angular/core';
    import { ProductsService, ProductModel } from 'src/app/products.service';

    @Component({
        selector: 'app-products',
        templateUrl: './products.component.html',
        styleUrls: ['./products.component.css']
    })
    export class ProductsComponent implements OnInit {

        allProducts: Array<ProductModel>;

        constructor(private productService: ProductsService) { }

        ngOnInit() {
            this.allProducts = this.productService.allProducts;
        }

    }
